import {Hero, PageContainer} from "./Policy";

const TermsPage = () => {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100">
            <Hero
                title="شرایط و مقررات استفاده از پلتفرم ونیفای"
                subtitle="با استفاده از خدمات پلتفرم ونیفای (که بر روی دیوار ارائه می‌شود)، شما به طور کامل با شرایط و مقررات زیر موافقت می‌کنید. این مقررات بخشی جدایی‌ناپذیر از قرارداد بین شما (کاربر) و ونیفای است. لطفاً پیش از استفاده، این متن را به دقت مطالعه نمایید. اگر با هر بخشی از آن موافق نیستید، از خدمات استفاده نکنید."
            />


            <PageContainer>
                <h2 className="text-lg font-bold">۱. مقدمه و دامنه کاربرد</h2>
                <p className="mb-2">
                    ونیفای یک پلتفرم دیجیتال برای ارائه خدمات احراز هویت و استعلام‌های مرتبط است، از جمله (تعدادی از
                    سرویس‌ها)
                </p>


                <ul className="list-disc list-inside ">
                    <li className="mb-1"> احراز هویت تصویری (بررسی چهره)</li>
                    <li className="mb-1"> احراز هویت حقوقی (بررسی روزنامه رسمی اعضای هیئت مدیره)</li>
                    <li className="mb-1"> استعلام مالکیت خودرو (با کد ملی و پلاک از پلیس راهور)</li>
                    <li className="mb-1">استعلام مالکیت ملک (با کد ملی و اطلاعات سند از سازمان ثبت اسناد)</li>
                    <li className="mb-1">استعلام اعتبار معاملاتی (با کد ملی از قوه قضاییه)</li>
                    <li className="mb-1">استعلام اصالت دستگاه (با IMEI)</li>
                    <li className="mb-1">استعلام خوش‌حسابی بانکی (با کد ملی)</li>
                    <li className="mb-1">استعلام مدارک و پروانه‌های کسب‌وکار (با کد ملی)</li>
                    <li className="mb-1">استعلام عدم سوءپیشینه (با کد ملی از پلیس اماکن)</li>
                </ul>
                <p className="mt-2">این خدمات تنها برای کاربران مجاز و بر اساس قوانین کشور ارائه می‌شود. ونیفای حق دارد
                    خدمات را در هر زمان تعلیق یا تغییر دهد.</p>
                <h2 className="text-lg mt-10 font-bold">۲. پذیرش شرایط</h2>
                <p className="mb-2">
                    استفاده از هر خدمتی به معنای پذیرش کامل این مقررات است.
                    <br/>
                    کاربران باید حداقل ۱۸ سال سن داشته باشند یا رضایت والدین/سرپرست قانونی را کسب کنند.
                    <br/>
                    ونیفای می‌تواند دسترسی را در صورت نقض مقررات، محدود یا مسدود کند.
                </p>

                <h2 className="text-lg mt-10 font-bold">
                    ۳. اطلاعات کاربر و مسئولیت‌ها
                </h2>
                <p className="mb-2">
                    شما موظفید اطلاعات دقیق، کامل و به‌روز ارائه دهید. اطلاعات نادرست منجر به رد درخواست، مسدودسازی حساب و پیگیری قانونی می‌شود.
                    <br/>
                    مسئولیت حفظ امنیت حساب کاربری (رمز عبور، دستگاه) بر عهده شماست. هر فعالیتی از حساب شما، به عنوان اقدام شما تلقی می‌شود.
                    <br/>
                    ارسال محتوای جعلی (مانند تصاویر یا ویدیوهای تقلبی) ممنوع است و عواقب حقوقی دارد.

                </p>
                <h2 className="text-lg mt-10 font-bold">
                    ۴. پرداخت و هزینه‌ها
                </h2>
                <p className="mb-2">

                    هزینه خدمات بر اساس تعرفه‌های اعلام‌شده (از طریق اپلیکیشن یا وب‌سایت) محاسبه می‌شود.
                    <br/>
                    ونیفای از درگاه‌های امن پرداخت استفاده می‌کند، اما مسئولیت خطاهای بانکی بر عهده کاربر است.
                </p>


                <h2 className="text-lg mt-10 font-bold">
                    ۵. استفاده از خدمات

                </h2>
                <p className="mb-2">
                    خدمات بر اساس داده‌های رسمی مراجع دولتی (مانند پلیس راهور، قوه قضاییه، سازمان ثبت) ارائه می‌شود.
                    ونیفای تضمینی برای ۱۰۰% دقت داده‌ها نمی‌دهد و مسئولیت خطاهای منابع خارجی بر عهده ونیفای نیست.
                    <br/>
                    استعلام‌ها تا زمان درخواست معتبر هستند و ونیفای مسئولیتی در قبال تغییرات بعدی ندارد.
                    <br/>
                    استفاده از خدمات برای مقاصد غیرقانونی، کلاهبرداری یا آسیب به دیگران ممنوع است و به مراجع قضایی گزارش
                    می‌شود.
                    <br/>
                    جمع‌آوری یا انتقال اطلاعات کاربران به اشخاص ثالث بدون مجوز، پیگرد قانونی دارد.
                </p>


                <h2 className="text-lg mt-10 font-bold">
                    ۶. مالکیت معنوی و محدودیت‌ها
                </h2>
                <p className="mb-2">

                    تمام محتوای پلتفرم (لوگوها، نرم‌افزارها) متعلق به ونیفای است و کپی‌برداری ممنوع می‌باشد.
                    استفاده خودکار (ربات‌ها) یا انتشار بدافزار از طریق پلتفرم، ممنوع و منجر به مسدودسازی می‌شود.
                </p>


                <h2 className="text-lg mt-10 font-bold">
                    ۷. تغییرات در مقررات

                </h2>
                <p className="mb-2">

                    ونیفای حق به‌روزرسانی این مقررات را در هر زمان دارد. تغییرات از طریق ایمیل، اپلیکیشن یا وب‌سایت
                    اطلاع‌رسانی می‌شود.
                    <br/>
                    ادامه استفاده پس از تغییرات، به معنای پذیرش آن‌هاست.
                </p>

                <h2 className="text-lg mt-10 font-bold">
                    ۸. حل اختلافات و مسئولیت حقوقی


                </h2>
                <p className="mb-2">

                    هرگونه اختلاف ابتدا از طریق پشتیبانی ونیفای (ایمیل، چت یا تماس تلفنی) پیگیری شود.
                    <br/>
                    ونیفای حداکثر مسئولیت خسارت را به مبلغ هزینه پرداختی محدود می‌کند. هیچ تضمینی برای سودهای از دست
                    رفته یا خسارات غیرمستقیم نمی‌دهد.
                    <br/>
                    این مقررات بر اساس قوانین ایران تفسیر می‌شود.

                </p>

                <h2 className="text-lg mt-10 font-bold">
                    ۹. فسخ و خاتمه

                </h2>
                <p className="mb-2">

                    ونیفای می‌تواند حساب را بدون اطلاع قبلی خاتمه دهد، به ویژه در موارد تخلف.
                    <br/>
                    شما می‌توانید با اطلاع‌رسانی، حساب را حذف کنید، اما اطلاعات پردازش‌شده طبق سیاست حریم خصوصی مدیریت می‌شود.


                </p>
                <br/><br/><br/><br/>
                <p>با تشکر از اعتماد شما، ونیفای متعهد به ارائه خدمات امن و کارآمد است.</p>
            </PageContainer>

        </div>
    );
};
export default TermsPage